/**
 * Companio FAQ accordion.
 *
 * Ported from the prototype: toggling .open on the item drives the
 * grid-template-rows transition, and the +/− glyph is swapped to match.
 * Items open independently — the prototype does not close siblings.
 */

class CompanioFaq extends HTMLElement {
  connectedCallback() {
    this.onClick = this.onClick.bind(this);
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick(event) {
    const button = event.target.closest('.faq-question');
    if (!button || !this.contains(button)) return;

    const item = button.closest('.faq-item');
    if (!item) return;

    const open = item.classList.toggle('open');
    button.setAttribute('aria-expanded', String(open));

    const glyph = button.querySelector('span');
    if (glyph) glyph.textContent = open ? '−' : '+';
  }
}

if (!customElements.get('companio-faq')) {
  customElements.define('companio-faq', CompanioFaq);
}
